export const getRemoteUtilityId = (): number => {
  try {
    const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
    
    if (loginResult.result?.remoteUtilityId) {
      return Number(loginResult.result.remoteUtilityId);
    }
  } catch (error) {
    console.error("Error parsing loginResult from localStorage:", error);
  }
  
  return 569; // Safe fallback
};
